<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    size="xl"
    scrollable
  >
    <b-card
      class="text-center resumen-vacaciones-modal"
      :body-class="[isDarkSkin ? 'custom-dark' : 'custom-light']"
    >
      <ResumenVacaciones :id="modalData.id" />
    </b-card>
  </b-modal>
</template>

<script>
import ResumenVacaciones from "@/views/rrhh/views/payroll/components/vacaciones/components/ResumenVacaciones.vue";
export default {
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  components: {
    ResumenVacaciones,
  },
  data() {
    return {
      showModal: true,
    };
  },
  computed: {
    title() {
      return `RESUMEN DE VACACIONES - ${this.modalData.empleado}`;
    },
  },
};
</script>

<style lang="scss">
.resumen-vacaciones-modal {
  .custom-dark {
    background-color: #111113 !important;
  }

  .custom-light {
    background-color: #f8f9fa !important;
  }
}
</style>